import { UseFormReturn } from 'react-hook-form';
import { IDocumentTable, ISetValue } from '@models/Forms/IForms';
import { IFieldElem } from '@models/IFormData';
import { GetValueForSetValue } from '@utils/managers/ChangesManager';
import { useCallback } from 'react';
import type { ISavedChangeField } from '@utils/managers/ChangesManager';

export function useFieldSaver(fields: Record<string, IFieldElem>, formMethods: UseFormReturn<any>) {
    return useCallback(
        async (item: ISetValue, table?: IDocumentTable, rowData?: any): Promise<ISavedChangeField> => {
            const val = await GetValueForSetValue(item, table?.key, fields, rowData, formMethods);
            const field = fields[item.key];
            if (field === undefined) {
                throw new Error(`Поле ${item.key} не найдено в перечне полей`);
            }
            formMethods.setValue(field.name as any, val, { shouldDirty: true });
            const savedValue = typeof formMethods.getValues === 'function' ? formMethods.getValues(field.name as any) : val;
            return { saved: true, value: savedValue };
        },
        [fields, formMethods],
    );
}
